import { BellOutlined, CheckCircleOutlined, CloseCircleOutlined, MessageOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { cn } from "../../lib/utils";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const actionTypeConfig = {
    SMS_SENT: {
        icon: MessageOutlined,
        color: "blue",
        label: "SMS Sent",
    },
    WORKLOG_APPROVED: {
        icon: CheckCircleOutlined,
        color: "green",
        label: "Approved",
    },
    WORKLOG_REJECTED: {
        icon: CloseCircleOutlined,
        color: "red",
        label: "Rejected",
    },
};

export default function WorklogNotificationTile({ action }) {
    const config = actionTypeConfig[action.actionType] || {
        icon: BellOutlined,
        color: "default",
        label: action.actionType,
    };

    const Icon = config.icon;
    const creatorName = `${action.createdBy?.firstName || ""} ${action.createdBy?.lastName || ""}`.trim();
    const projectName = action.worklog?.project?.name || "Unknown Project";
    const taskName = action.worklog?.task?.name || "Unknown Task";
    const timeAgo = dayjs(action.createdAt).fromNow();

    return (
        <div className="flex items-start space-x-3 w-full px-4 py-3 hover:bg-gray-50 transition-colors">
            <div className="flex-shrink-0 mt-1">
                <Icon className="h-5 w-5 text-[20px]" style={{ color: config.color }} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                    <p className="text-sm">
                        {action.actionType === "SMS_SENT" && (
                            <span>SMS sent for worklog </span>
                        )}
                        {action.actionType === "WORKLOG_APPROVED" && (
                            <span>Worklog approved for </span>
                        )}
                        {action.actionType === "WORKLOG_REJECTED" && (
                            <span>Worklog rejected for </span>
                        )}
                        <Link to={`/worklogs?id=${action.worklog?.id}`} className="text-blue-500 hover:underline font-medium">
                            #{action.worklog?.id}
                        </Link>
                    </p>
                    <Tag color={config.color} className="flex-shrink-0">
                        {config.label}
                    </Tag>
                </div>
                <p className="text-xs text-gray-500 mt-1">{timeAgo}</p>
            </div>
        </div>
    );
}
